export default "__VITE_ASSET__71944ffd__"